import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFavoriteFillH18(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    fill: "none",
    viewBox: "0 0 18 18",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.487 6.813c0 1.311-.58 2.412-1.314 3.255l-.001-.001c-.39.472-1.672 1.814-2.905 3.078-1.251 1.282-2.515 2.55-2.83 2.834a.65.65 0 0 1-.87 0c-.315-.283-1.58-1.551-2.833-2.833-1.249-1.279-2.55-2.636-2.922-3.094-.728-.84-1.302-1.936-1.302-3.239C1.51 4.3 3.48 2.22 5.96 2.22a4.36 4.36 0 0 1 3.038 1.24 4.36 4.36 0 0 1 3.04-1.24c2.48 0 4.45 2.08 4.45 4.593"
  }));
}
var IcFavoriteFillH18 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFavoriteFillH18));

export { IcFavoriteFillH18 as I };
